"use client";

import { useMemo, useState } from "react";
import { Button, Anchor as MantineAnchor, Box as MantineBox } from "@mantine/core";

import { MensTopsTable } from "./MensTopsTable";
import { WomensTopsTable } from "./WomensTopsTable";
import { BottomsTable } from "./BottomsTable";
import { ShoesTable } from "./ShoesTable";

import styles from "./styles.module.scss";

type Props = {
  category?: "mensTops" | "womensTops" | "bottom" | "shoes";
};

const SizeTable = ({ category = "shoes" }: Props) => {
  const [active, setActive] = useState(category);

  const activeTable = useMemo(() => {
    switch (active) {
      case "mensTops":
        return <MensTopsTable />;
      case "womensTops":
        return <WomensTopsTable />;
      case "bottom":
        return <BottomsTable />;
      case "shoes":
        return <ShoesTable />;
      default:
        return <MensTopsTable />;
    }
  }, [active]);

  return (
    <MantineBox className={styles.sizeTableContainer}>
      <MantineBox className={styles.infoPrompt}>
        Read more about fine tuning your sizing&nbsp;
        <MantineAnchor href="/blog/how-to-find-your-clothing-sizes" className={styles.promptLink}>
          here!
        </MantineAnchor>
      </MantineBox>
      <MantineBox className={styles.buttonContainer}>
        <Button
          className={styles.categoryButton}
          data-active={active === "mensTops"}
          onClick={() => setActive("mensTops")}
        >
          Mens Tops
        </Button>
        <Button
          className={styles.categoryButton}
          data-active={active === "womensTops"}
          onClick={() => setActive("womensTops")}
        >
          Womens Tops/Dresses
        </Button>
        <Button
          className={styles.categoryButton}
          data-active={active === "bottom"}
          onClick={() => setActive("bottom")}
        >
          Bottom
        </Button>
        <Button
          className={styles.categoryButton}
          data-active={active === "shoes"}
          onClick={() => setActive("shoes")}
        >
          Shoes
        </Button>
      </MantineBox>
      <MantineBox className={styles.sizeTable}>{activeTable}</MantineBox>
    </MantineBox>
  );
};

export default SizeTable;
